import React from 'react';
const Preloader=()=>{
    return(
        <div className="uk-modal uk-open" id="preloader-modal" style={{'display': 'block', 'overflowY':'scroll !important'}}>
            <div className="uk-modal-dialog">
                <div>
                    <div className="uk-margin uk-modal-content">
                        <div id="blocking_preloader" className="uk-text-center">Please wait loading...<br/> <i className="uk-icon-refresh uk-icon-medium uk-icon-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preloader;


// WEBPACK FOOTER //
// ./src/core/Preloader.js